import { Form } from 'antd';
import { Box, Colors, IcFilter, InputSearch, Select } from 'basic-ui-lib';
import { debounce } from 'lodash';
import { StatusOptions } from 'modules/dashboard/services/constants';
import { useGetAllStores } from 'modules/dashboard/services/hooks';
import useGetListScreens from 'modules/dashboard/services/hooks/useGetListScreens';
import { useEffect, useMemo, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import styled from 'styled-components';
import ScreenFilterDrawerMobile from './ScreenFilterDrawerMobile';

type FormValues = {
  keySearch: string;
  status: string;
  storeId: string;
};

const ScreenFilter = () => {
  const [form] = Form.useForm<FormValues>();
  const { mutate } = useGetListScreens(true);
  const { stores } = useGetAllStores();
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);

  const onFinish = (values: FormValues) => {
    mutate({
      keySearch: values.keySearch || '',
      status: values.status || '',
      storeId: values.storeId || '',
      page: 1,
      size: 10,
    });
  };

  const debouncedSearch = useMemo(
    () =>
      debounce(() => {
        form.submit();
      }, 500),
    [form],
  );

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const storeOptions = useMemo(() => {
    return [
      { label: 'All Stores', value: '' },
      ...stores.map((store) => ({
        label: store.storeName,
        value: store.storeId,
      })),
    ];
  }, [stores]);

  return (
    <Container>
      <Form form={form} layout='vertical' className='form-container' onFinish={onFinish}>
        <Form.Item name='keySearch' noStyle>
          <InputSearch placeholder='Search screens by name, location,...' onChange={debouncedSearch} />
        </Form.Item>
        {isMobile ? (
          <button type='button' onClick={() => setIsOpenDrawer(true)}>
            <Box width={48} height={48} display='flex' justifyContent='center' alignItems='center' padding={10} backgroundColor={Colors.neutral.bg[5]} borderRadius={4}>
              <IcFilter width={24} height={24} />  
            </Box>
          </button>
        ) : (
          <>
            <Form.Item name='status' noStyle>
              <Select options={StatusOptions} onChange={() => form.submit()} placeholder='Select Status'/>
            </Form.Item>
            <Form.Item name='storeId' noStyle>
              <Select options={storeOptions} onChange={() => form.submit()} placeholder='Select Store'/>
            </Form.Item>
          </>
        )}
      </Form>
      <ScreenFilterDrawerMobile open={isOpenDrawer} onClose={() => setIsOpenDrawer(false)} />
    </Container>
  );
};

export default ScreenFilter;

const Container = styled.div`
  width: 100%;

  .form-container {
    width: 100%;
    display: flex;
    gap: 16px;
  }

  .custom-select .ant-select-selector {
    width: 180px;
  }


  @media (max-width: 768px) {
    .form-container {
      gap: 8px;
    }
  }
`;
